export class User {
  id?: number;
  username?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  token?: string;
  email?: string;
  role?: string;
  ragionesociale: string;
  enable?: boolean;
  gdpr?: boolean;
   nome?: string;
  cognome?: string; 
  telefono?: string;
  iva?: string;
  codicefiscale?: string;
}
